export const getMimeType = (extension: string): string => {
  switch (extension.toLowerCase()) {
    case 'pdf':
      return 'application/pdf';
    case 'txt':
      return 'text/plain';
    case 'jpg':
    case 'jpeg':
      return 'image/jpeg';
    case 'png':
      return 'image/png';
    case 'html':
      return 'text/html';
    case 'json':
      return 'application/json';
    case 'csv':
      return 'text/csv';
    default:
      return 'application/octet-stream';
  }
};

/** Opens a blob in a new browser tab (same pattern as ClientApp2). */
export const openFileNewTab = (file: Blob, extension: string): void => {
  const fileBlob = new Blob([file], { type: getMimeType(extension) });
  const url = URL.createObjectURL(fileBlob);
  window.open(url, '_blank');
};
